import { useMemo } from "react";
import { Route } from "react-router-dom";
import { TabLayout } from "../../ui_elements";

export const PGRepAssignmentRouter = ({
  component,
  path,
  exact,
  purpose,
  title,
  user,
  ...rest
}) => {

  const Component = component;
  

  const paths = useMemo(
    () => [
      {
        title: "Assign Faculty Rep",
        path: "/pg_rep_assignment/assign_faculty_rep",
        disabled: false
      },
      {
        title: "Assign Departmental Coordinator",
        path: "/pg_rep_assignment/assign_departmental_coordinator",
        disabled: false
      },
    ],
    []
  )


  return (
    <Route
      exact={exact}
      path={path}
      {...rest}
      render={(props) => {
        return (
          <TabLayout title={title} paths={paths}>
            <Component purpose={purpose} user={user} {...props} />
          </TabLayout>
        );
      }}
    />
  )
}